var map = {
	"./API/ApiTokenManager": 62208,
	"./API/ApiTokenManager.vue": 62208,
	"./API/Index": 62606,
	"./API/Index.vue": 62606,
	"./AboutUs/Index": 93449,
	"./AboutUs/Index.vue": 93449,
	"./Account/AccountInformation": 78192,
	"./Account/AccountInformation.vue": 78192,
	"./Account/old_AccountInformation": 84307,
	"./Account/old_AccountInformation.vue": 84307,
	"./AppStore/Index": 43371,
	"./AppStore/Index.vue": 43371,
	"./Auth/ConfirmPassword": 64627,
	"./Auth/ConfirmPassword.vue": 64627,
	"./Auth/ForgotPassword": 76516,
	"./Auth/ForgotPassword.vue": 76516,
	"./Auth/Login": 80655,
	"./Auth/Login.vue": 80655,
	"./Auth/Register": 64168,
	"./Auth/Register.vue": 64168,
	"./Auth/ResetPassword": 44440,
	"./Auth/ResetPassword.vue": 44440,
	"./Auth/TwoFactorChallenge": 11845,
	"./Auth/TwoFactorChallenge.vue": 11845,
	"./Auth/VerifyEmail": 90936,
	"./Auth/VerifyEmail.vue": 90936,
	"./Auth/VerifyLinkExpired": 87465,
	"./Auth/VerifyLinkExpired.vue": 87465,
	"./Banks/Index": 20623,
	"./Banks/Index.vue": 20623,
	"./Brands/Index": 96006,
	"./Brands/Index.vue": 96006,
	"./Categories/Index": 36663,
	"./Categories/Index.vue": 36663,
	"./Categories/Show": 63414,
	"./Categories/Show.vue": 63414,
	"./Chat/AdminIndex": 55631,
	"./Chat/AdminIndex.vue": 55631,
	"./Chat/Index": 82726,
	"./Chat/Index.vue": 82726,
	"./Commons/Index": 78120,
	"./Commons/Index.vue": 78120,
	"./Complain/Create": 84591,
	"./Complain/Create.vue": 84591,
	"./Complain/Index": 96376,
	"./Complain/Index.vue": 96376,
	"./Complain/Show": 29982,
	"./Complain/Show.vue": 29982,
	"./CreditRequest/Assign": 10228,
	"./CreditRequest/Assign.vue": 10228,
	"./CreditRequest/Create": 90604,
	"./CreditRequest/Create.vue": 90604,
	"./CreditRequest/Index": 6507,
	"./CreditRequest/Index.vue": 6507,
	"./Dashboard": 30785,
	"./Dashboard.vue": 30785,
	"./FeaturedImages/Index": 47958,
	"./FeaturedImages/Index.vue": 47958,
	"./Invoice": 17529,
	"./Invoice.vue": 17529,
	"./Invoices/ChangeStatusDemo": 73703,
	"./Invoices/ChangeStatusDemo.vue": 73703,
	"./Invoices/Dispatch": 70554,
	"./Invoices/Dispatch.vue": 70554,
	"./Invoices/Index": 34264,
	"./Invoices/Index.vue": 34264,
	"./Invoices/ShowDispatch": 29196,
	"./Invoices/ShowDispatch.vue": 29196,
	"./Invoices/ToDelivered": 70257,
	"./Invoices/ToDelivered.vue": 70257,
	"./Invoices/ToShipped": 80691,
	"./Invoices/ToShipped.vue": 80691,
	"./Invoices/_ToDelivered": 24059,
	"./Invoices/_ToDelivered.vue": 24059,
	"./Kyc/Create": 39204,
	"./Kyc/Create.vue": 39204,
	"./Kyc/Index": 82773,
	"./Kyc/Index.vue": 82773,
	"./Kyc/KycForm": 17516,
	"./Kyc/KycForm.vue": 17516,
	"./Kyc/KycShow": 85335,
	"./Kyc/KycShow.vue": 85335,
	"./Kyc/Show": 73333,
	"./Kyc/Show.vue": 73333,
	"./LocationLogs/Index": 52925,
	"./LocationLogs/Index.vue": 52925,
	"./Logs/ActivityLogIndex": 88681,
	"./Logs/ActivityLogIndex.vue": 88681,
	"./Logs/ErrorLogIndex": 23162,
	"./Logs/ErrorLogIndex.vue": 23162,
	"./Notifications/Index": 84027,
	"./Notifications/Index.vue": 84027,
	"./Payments/ChequePayments": 37860,
	"./Payments/ChequePayments.vue": 37860,
	"./Payments/Collections": 95035,
	"./Payments/Collections.vue": 95035,
	"./PrivacyPolicy": 34908,
	"./PrivacyPolicy.vue": 34908,
	"./ProductCart": 28773,
	"./ProductCart.vue": 28773,
	"./ProductFeaturedImages/Index": 90742,
	"./ProductFeaturedImages/Index.vue": 90742,
	"./Products/AdminView": 46534,
	"./Products/AdminView.vue": 46534,
	"./Products/Index": 71049,
	"./Products/Index.vue": 71049,
	"./Products/RetailerView": 28693,
	"./Products/RetailerView.vue": 28693,
	"./Products/Show": 83305,
	"./Products/Show.vue": 83305,
	"./Profile/DeleteUserForm": 11891,
	"./Profile/DeleteUserForm.vue": 11891,
	"./Profile/LogoutOtherBrowserSessionsForm": 38814,
	"./Profile/LogoutOtherBrowserSessionsForm.vue": 38814,
	"./Profile/Show": 46466,
	"./Profile/Show.vue": 46466,
	"./Profile/TwoFactorAuthenticationForm": 40577,
	"./Profile/TwoFactorAuthenticationForm.vue": 40577,
	"./Profile/UpdatePasswordForm": 22136,
	"./Profile/UpdatePasswordForm.vue": 22136,
	"./Profile/UpdateProfileInformationForm": 41957,
	"./Profile/UpdateProfileInformationForm.vue": 41957,
	"./Promocodes/Index": 39966,
	"./Promocodes/Index.vue": 39966,
	"./PurchaseHistory/Index": 7077,
	"./PurchaseHistory/Index.vue": 7077,
	"./PurchaseHistory/Show": 65220,
	"./PurchaseHistory/Show.vue": 65220,
	"./PurchaseHistory/_index": 17670,
	"./PurchaseHistory/_index.vue": 17670,
	"./Reports/AdminReport": 1465,
	"./Reports/AdminReport.vue": 1465,
	"./Reports/BillsOfRetailer": 52518,
	"./Reports/BillsOfRetailer.vue": 52518,
	"./Reports/BillsOfWholesaler": 91275,
	"./Reports/BillsOfWholesaler.vue": 91275,
	"./Reports/Old-TransactionsOfBill": 99821,
	"./Reports/Old-TransactionsOfBill.vue": 99821,
	"./Reports/RetailerInvoiceReport": 61811,
	"./Reports/RetailerInvoiceReport.vue": 61811,
	"./Reports/RetailerReport": 68689,
	"./Reports/RetailerReport.vue": 68689,
	"./Reports/TransactionsOfBill": 1353,
	"./Reports/TransactionsOfBill.vue": 1353,
	"./Reports/WholesalerReport": 41346,
	"./Reports/WholesalerReport.vue": 41346,
	"./Reports/_RetailerReportIndex": 65283,
	"./Reports/_RetailerReportIndex.vue": 65283,
	"./RetailerStatement": 22350,
	"./RetailerStatement.vue": 22350,
	"./StockChanges/Index": 98101,
	"./StockChanges/Index.vue": 98101,
	"./StockChanges/ProductScopedIndex": 89314,
	"./StockChanges/ProductScopedIndex.vue": 89314,
	"./TermsOfService": 26500,
	"./TermsOfService.vue": 26500,
	"./UserManagement/AssignedRetailers": 65628,
	"./UserManagement/AssignedRetailers.vue": 65628,
	"./UserManagement/Index": 62516,
	"./UserManagement/Index.vue": 62516,
	"./UserManagement/RetailerUsersIndex": 14296,
	"./UserManagement/RetailerUsersIndex.vue": 14296,
	"./UserManagement/SalesPersonDashboard": 96392,
	"./UserManagement/SalesPersonDashboard.vue": 96392,
	"./UserManagement/old-index": 76488,
	"./UserManagement/old-index.vue": 76488,
	"./Welcome": 43397,
	"./Welcome.vue": 43397,
	"./WholesalerStatement": 37685,
	"./WholesalerStatement.vue": 37685,
	"./Wholesalers/Index": 16638,
	"./Wholesalers/Index.vue": 16638,
	"./__ProductCart": 29015,
	"./__ProductCart.vue": 29015,
	"./old-dashboard": 81223,
	"./old-dashboard.vue": 81223,
	"./old-retailer-invoice": 29753,
	"./old-retailer-invoice.vue": 29753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88846;